/* eslint-disable react/no-danger */

import React from 'react';
import propTypes from 'prop-types';
import { DropTarget } from 'react-dnd';
import { useDispatch } from 'react-redux';
import cn from 'classnames';
import { HABIT } from '~/Config/DragTypes';
import { openModal, setModalData } from '~/Redux/Modules/Modal';
import { HABIT_CREATE_EDIT_MODAL } from '~/Config/Modals';
import { updateHabit } from '~/Redux/Modules/Habits';
import Store from '~/Redux/Store';
import { nextPriority } from './helpers';
import './HabitsColumn.scss';

const habitTarget = {
  canDrop: () => {
    return true;
  },
  drop: ({ prevHabit }, monitor) => {
    const { habit } = monitor.getItem();
    Store.dispatch(
      updateHabit({
        ...habit,
        priority: nextPriority(null, prevHabit),
      })
    );
  },
};

const dropCollect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  isOver: monitor.isOver(),
  dragItem: monitor.getItem(),
  monitor: monitor,
});

const LastPlaceholderHabit = ({ connectDropTarget, prevHabit, isOver }) => {
  const dispatch = useDispatch();

  return connectDropTarget(
    <div
      className={cn('habit-row', 'empty', {
        'is-over': isOver,
        'not-first-child': prevHabit !== null,
      })}
      onClick={() => {
        dispatch(setModalData({ habit: null }));
        dispatch(openModal(HABIT_CREATE_EDIT_MODAL));
      }}
    />
  );
};

LastPlaceholderHabit.propTypes = {
  prevHabit: propTypes.shape({
    priority: propTypes.string,
  }),
  isOver: propTypes.bool,
  connectDropTarget: propTypes.func,
};

export default LastPlaceholderHabit |> DropTarget(HABIT, habitTarget, dropCollect);
